// src/TermsOfService.js
import React from "react";

function TermsOfService() {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms of Service</h1>

      <p>
        Welcome to "Who Pays? – Bill Games" (the "App"). By using our App, you
        agree to these Terms of Service (the "Terms"). Please read them
        carefully.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using the App, you agree to comply with and be bound by
        these Terms. If you do not agree with these Terms, you should not use
        the App.
      </p>

      <h2>2. Use of the App</h2>
      <p>
        The App provides various entertaining game modes to help groups and
        friends decide who pays a bill, perform challenges, or make decisions
        through interactive randomness. You agree to use the App only for
        lawful, social, and entertainment purposes.
      </p>

      <h2>3. No Collection of Personal Data</h2>
      <p>
        We do not collect, store, or share any personal information about you.
        All actions and entries within the App stay on your device and are not
        transmitted elsewhere.
      </p>

      <h2>4. Prohibited Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the App for any illegal or harmful purpose.</li>
        <li>Disrupt or interfere with the App’s functionality.</li>
        <li>Attempt to reverse engineer or tamper with the App's code.</li>
      </ul>

      <h2>5. Ads and Monetization</h2>
      <p>The App may display third-party advertisements.</p>

      <h2>6. Disclaimers</h2>
      <p>
        The App is provided "as is" without warranties of any kind. We do not
        guarantee that the App will be error-free, secure, or uninterrupted. Use
        the App at your own discretion and risk.
      </p>

      <h2>7. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. All updates will be posted
        here with the new effective date. Continued use after changes means
        acceptance of the new Terms.
      </p>

      <h2>8. Termination</h2>
      <p>
        We reserve the right to terminate or suspend access to the App without
        prior notice if these Terms are violated.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions about these Terms or the App, please contact
        us at:
      </p>
      <p>
        Email:{" "}
        <a href="mailto:mega.mobile2267@gmail.com">mega.mobile2267@gmail.com</a>
      </p>
    </div>
  );
}

export default TermsOfService;
